export class CustomParamsDisplayTriageFSControlModel {
  DisplayTriage: boolean;
  DisplayFamilyServices: boolean
}
